export default "__VITE_ASSET__DWPRtt1J__"